import { useMemo } from 'react';
import { css } from '@emotion/react';
import { Info } from '@phosphor-icons/react';
import { Flip, TypographyProps } from 'client/components/Typography';
import { Transition } from 'client/Theme';

const messageStyle = css`
  transition: margin ${Transition.basic};

  &:not(.empty) {
    margin-top: 1px;
  }

  > svg {
    margin-right: 3px;
    transform: translateY(2px);
  }
`;

export interface StatusTreeItemMessageProps extends TypographyProps {
  message?: string | null;
}

export const StatusTreeMessage = ({ message = null, ...other }: StatusTreeItemMessageProps) => {
  const content = useMemo(
    () =>
      message ? (
        <>
          <Info weight="bold" />
          {message}
        </>
      ) : (
        ''
      ),
    [message]
  );

  return (
    <Flip variant="body2" component="p" css={messageStyle} {...other}>
      {content}
    </Flip>
  );
};
